import VRouter from '@/common/models/virtualRouter.model';

export default {
  name: 'routers',
  Model: VRouter,
  singular: 'router',
  socketUpdates: true,
  pagingSupport: true,
  resource: '/api/v2/compute/routers',
  getters: {
    getRouterInterfaces: state => id => state.itemsMap[id]?.interfaces,
    getRouterRoutes: state => id => state.itemsMap[id]?.routes,
  },
  actions: ({ Model, resource }) => ({
    FETCH_ITEM({ commit, dispatch }, { id, params = {} }) {
      return this.$api.get(`${resource}/${id}`, { params })
        .then((res) => {
          const item = new Model(res.data);
          commit('CHANGE', { item });
          return res;
        })
        .then(() => dispatch('FETCH_ROUTER_INTERFACES', { id }))
        .catch((error) => {
          commit('SET_ERRORS', error);

          throw error;
        });
    },
    FETCH_ROUTER_INTERFACES({ dispatch }, { id }) {
      return this.$api.get(`/api/v2/compute/routers/${id}/interfaces`)
        .then(response => dispatch('ROUTER_INTERFACE_APPLY', response));
    },
    ADD_ROUTER_INTERFACE({ dispatch }, { routerId, body }) {
      return this.$api.put(`/api/v2/compute/routers/${routerId}/add_interface`, body)
        .then(response => dispatch('ROUTER_INTERFACE_APPLY', response));
    },
    ROUTER_INTERFACE_APPLY({ commit, getters }, response) {
      const router = getters.getItemById(response.data.router_id);
      const item = new Model({
        ...(router?.toJS() || {}),
        router_id: response.data.router_id,
        interfaces_info: response.data.internal_interfaces,
        external_interface: response.data.external_interface
      });

      commit('CHANGE', { item, addToList: false });
      return response;
    },
    REMOVE_ROUTER_INTERFACE({ dispatch }, { routerId, item }) {
      return this.$api.put(`/api/v2/compute/routers/${routerId}/remove_interface`, { network_id: item.network_id })
        .then(response => dispatch('ROUTER_INTERFACE_APPLY', response));
    },
    REMOVE_ROUTER_INTERFACES({ dispatch }, { routerId, items }) {
      return Promise.all(
        items.map(item => item.type === 'external'
          ? dispatch('UPDATE', { id: routerId, body: { external_gateway_info: null } })
          : dispatch('REMOVE_ROUTER_INTERFACE', { routerId, item })
        )
      );
    }
  }),
};
